// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'fast-forward-solid';

export const Component = () => (
  <path d='M7.848 3c.24 0 .432.048.527.144l14.75 8.381c.247.205.388.445.423.691l.009.123c0 .293-.11.514-.33.724l-.101.09-14.751 8.334c-.096.096-.287.143-.527.143a.946.946 0 0 1-.67-.287.96.96 0 0 1-.28-.551l-.007-.12-.002-1.674-4.405 2.489c-.096.096-.287.143-.526.143a.946.946 0 0 1-.67-.287.96.96 0 0 1-.28-.551L1 20.672V3.959c0-.24.096-.48.288-.67A.946.946 0 0 1 1.958 3c.239 0 .431.048.526.144L6.89 5.647l.002-1.69a.95.95 0 0 1 .287-.67A.946.946 0 0 1 7.848 3Z' />
);

export const viewBox = '0 0 25 25';
